import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import ModalButtons from '../../components/Modal/ModalButtons';
import Teams from '../../assets/teams.mp3';
import { useDispatch, useSelector } from 'react-redux';
import { CALL_ANSWER, CALL_DECLINE } from '../../redux/constants/userConstants';

const CallModal = ({ callModal, onDecline }) => {
	const { t } = useTranslation();
	// const { deleteEmail, setDeleteEmail, deleteUserData } = data;

	const callReducer = useSelector((state) => state.callReducer);
	const Audio = useRef();
	const dispatch = useDispatch()
	useEffect(() => {
		if (callModal)
			Audio?.current?.play();
	}, [callModal]);
	return (
		<Modal show={callModal}>
			<audio src={Teams} loop ref={Audio} />
			<ModalHeading heading={t('screens.video.call.incomingFrom', { name: (callReducer && callReducer.data) ? callReducer.data.name : '' })} />
			<ModalButtons
				submitButtonLabel={t('screens.video.call.answer')}
				onSubmit={() => {
					Audio?.current?.pause();
					dispatch({ type: CALL_ANSWER, payload: callReducer.data })
				}}
				cancelButtonLabel={t('screens.video.call.decline')}
				onCancel={() => {
					Audio?.current?.pause();
					dispatch({ type: CALL_DECLINE, payload: {} });
					onDecline()
				}}
			/>
		</Modal>
	);
};

export default CallModal;
